export default __webpack_public_path__ + "static/img-motogp-ignition-dfee995b44cbd1bdfd1f39f2e4af7eab.png";